import { initialState } from '@redux/store';

const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SAVE_CART':
      return {
        ...state,
        ...action.payload
      }
    default:
      return state;
  }
}
export default cartReducer;
